type Area = { x: number; y: number; width: number; height: number }

function createImage(url: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.addEventListener('load', () => resolve(img))
    img.addEventListener('error', (e) => reject(e))
    img.crossOrigin = 'anonymous'
    img.src = url
  })
}

export async function cropImageToBlob(args: {
  imageUrl: string
  croppedAreaPixels: Area
  mimeType?: 'image/png' | 'image/jpeg' | 'image/webp'
  quality?: number
}): Promise<Blob> {
  const {
    imageUrl,
    croppedAreaPixels,
    // ✅ 默认改成 webp（更小体积、支持透明）
    mimeType = 'image/webp',
    quality = 0.92,
  } = args

  const image = await createImage(imageUrl)

  const canvas = document.createElement('canvas')
  const ctx = canvas.getContext('2d')
  if (!ctx) throw new Error('Canvas context not available')

  const x = Math.max(0, Math.floor(croppedAreaPixels.x))
  const y = Math.max(0, Math.floor(croppedAreaPixels.y))
  const width = Math.max(1, Math.floor(croppedAreaPixels.width))
  const height = Math.max(1, Math.floor(croppedAreaPixels.height))

  canvas.width = width
  canvas.height = height

  // ✅ jpeg 没透明通道：先铺白底更稳（可选但建议）
  if (mimeType === 'image/jpeg') {
    ctx.fillStyle = '#fff'
    ctx.fillRect(0, 0, width, height)
  }

  ctx.drawImage(image, x, y, width, height, 0, 0, width, height)

  const blob = await new Promise<Blob>((resolve, reject) => {
    canvas.toBlob(
      (b) => {
        if (!b) return reject(new Error(`canvas.toBlob returned null for ${mimeType}`))
        // ✅ 兜底：某些环境 b.type 可能是空字符串
        if (!b.type) return resolve(new Blob([b], { type: mimeType }))
        resolve(b)
      },
      mimeType,
      mimeType === 'image/jpeg' || mimeType === 'image/webp' ? quality : undefined
    )
  })

  return blob
}
